module.exports = __webpack_public_path__ + "img/new_p_3.9de2510d.png";